import React from "react";

const Inquiry = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M9.128 27.615 2 33V4.538c0-.408.169-.799.469-1.087C2.769 3.162 3.176 3 3.6 3h28.8c.424 0 .831.162 1.131.45.3.29.469.68.469 1.088v21.539c0 .408-.169.8-.469 1.088-.3.288-.707.45-1.131.45H9.128Zm7.272-7.692V23h3.2v-3.077h-3.2Zm-3.893-7.98 3.14.605c.088-.429.302-.824.616-1.14.314-.317.714-.541 1.155-.647.441-.106.904-.09 1.336.048.431.138.813.39 1.102.728a2.23 2.23 0 0 1 .314 2.45 2.34 2.34 0 0 1-.886.963 2.47 2.47 0 0 1-1.284.358h-1.6v3.077H18c1.06 0 2.099-.29 2.995-.836a5.458 5.458 0 0 0 2.065-2.246 5.2 5.2 0 0 0 .496-2.96 5.281 5.281 0 0 0-1.227-2.757 5.61 5.61 0 0 0-2.57-1.698 5.814 5.814 0 0 0-3.117-.112 5.654 5.654 0 0 0-2.696 1.507 5.318 5.318 0 0 0-1.439 2.66Z"
            fill={fill}
        />
    </svg>
);

export default Inquiry;
